import { Pipe } from '@angular/core';

@Pipe({
  name: 'frenchDateFormat'
})
export class FrenchDateFormat {
  transform(value: string) : string {
    return value.split('-').reverse().join('-');
  }
}